import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()
export class FootprintProvider {
  private url: string = "footprints";

  constructor(public api: Api) {}

  post(toUserId: number): Observable<any> {
    return this.api.post(this.url, { user_id: toUserId });
  }
}



// WEBPACK FOOTER //
// ./src/providers/footprint/footprint.ts